<script>
import { Bar, mixins } from 'vue-chartjs';
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    filter : {
      type: String,
    },
    data: []
  },
  data: () => ({
    marketChartData: {
      labels: [],
      datasets: [
        {
          order: 1,
          type: 'line',
          fill: false,
          label: 'Giá trung bình',
          backgroundColor: 'transparent',
          borderColor: '#00796b',
          data: []
        },
        {
          order: 2,
          type: 'bar',
          fill: false,
          label: 'Giá thấp',
          barPercentage: 0.8,
          backgroundColor: '#f87979',
          borderColor: '#f87979',
          data: []
        },
        {
          order: 3,
          type: 'bar',
          fill: false,
          label: 'Giá cao',
          barPercentage: 0.8,
          backgroundColor: '#92f879',
          borderColor: '#92f879',
          data: []
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          // ticks: {
          //   display: false
          // },
          scaleLabel: {
            display: true,
            labelString: 'Tháng trong năm'
          }
        }],
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: 'Giá (Ngàn đồng)'
          },
          ticks: {
            beginAtZero: true,
            callback: function(value, index, values) {
              if(parseInt(value) >= 1000){
                return (value/1000).toString();
              } else {
                return value;
              }
            }
          }
        }]
      },
      tooltips: {
        callbacks: {
          title: function(tooltipItem, data) {
            return `Tháng ${data['labels'][tooltipItem[0]['index']]}`;
          },
          label: function(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || '';
            if (label) {
              label += ': ';
            }
            let value_tmp = Math.round(tooltipItem.yLabel * 100) / 100;
            let value = value_tmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            label += `${value} đ`;
            return label;
          }
        }
      },
      plugins: {
        datalabels: {
          formatter: (value) => {
            if(parseInt(value) >= 1000){
              return (value/1000).toString() + 'k';
            } else {
              return value + 'k';
            }
          },
          display: function(context) {
            return context.dataset.order !== 1
          },
          color: 'black',
        },
      },
      legend: {
        display: false
      },
      legendCallback: function(chart) {
        var text = [];
        text.push('<ul id="customlegend" class="' + chart.id + '-legend">');
        var data = chart.data;
        var datasets = data.datasets;
        if (datasets.length) {
          for (var i = 0; i < datasets.length; ++i) {
            text.push('<li>');
            if (datasets[i].type=='line') {
              text.push('<span class="'+datasets[i].type+'" style="background-color:' + datasets[i].borderColor + ';margin-bottom: 3px;"></span>');
            } else {
              text.push('<span class="'+datasets[i].type+'" style="background-color:' + datasets[i].backgroundColor + '"></span>');
            }
            text.push('<label>' + datasets[i].label + '</label>');
            text.push('</li>');
          }
        }
        text.push('</ul>');
        return text.join('');
      }
    }
  }),
  watch: {
    data(){
      this.init();
    }
  },
  mounted() {
    Chart.plugins.register(ChartJsPluginDataLabels);
    this.addPlugin(ChartJsPluginDataLabels);
    this.init();
    
  },
  methods: {
    init(){
      const app = this;
      app.marketChartData.labels = [];
      app.marketChartData.datasets[0].data = [];
      app.marketChartData.datasets[1].data = [];
      app.marketChartData.datasets[2].data = [];

      app.data.forEach(function(el){
        if(app.filter == 'year'){
          app.marketChartData.labels.push(`${el.ngay} Tháng ${el.thang}, ${el.nam}`);
        } else if(app.filter == 'month'){
          app.marketChartData.labels.push(`Tháng ${el.thang}`);
        } else {
          app.marketChartData.labels.push(`${el.ngay} Tháng ${el.thang} (Tuần ${el._week})`);
        }
        app.marketChartData.datasets[1].data.push(el.l_price_tb);
        app.marketChartData.datasets[2].data.push(el.h_price_tb);
        app.marketChartData.datasets[0].data.push((parseInt(el.h_price_tb)+parseInt(el.l_price_tb))/2);
      })
      app.renderChart(app.marketChartData, app.options);
      // app.addCurrentYearHighlight();
      
      Chart.plugins.unregister(ChartJsPluginDataLabels);
      app.$emit('finish');
      const HTML = app.$data._chart.generateLegend();

      setTimeout(function() {
        document.querySelectorAll("#customlegend li").forEach((item, i) => {
          item.addEventListener("click", (e) => app.updateDataset(e.target.parentNode, i));
        })
      }, 0);
      
      app.$emit('generated', HTML);
    },
    updateDataset(currentEl, index){
      // const meta = this.$data._chart.getDatasetMeta(0);
      const labelEl = currentEl.querySelector("label");
      const result = this.$data._chart.data.datasets[index].hidden === true ? false : true;
      if (result === true) {
        // meta.data[index].hidden = true;
        labelEl.style.textDecoration = "line-through";
      } else {
        labelEl.style.textDecoration = "none";
        // meta.data[index].hidden = false;
      }
      this.$data._chart.data.datasets[index].hidden = !this.$data._chart.data.datasets[index].hidden;
      this.$data._chart.update()
    },
    addCurrentYearHighlight() {
      const app = this;
      Chart.pluginService.register({
        afterDraw: function(chart) {
          var ctx = chart.chart.ctx;
          var xAxis = chart.scales['x-axis-0'];
          var yAxis = chart.scales['y-axis-0'];
          ctx.save();
          ctx.textAlign = 'center';
          ctx.font = '12px Arial';
          if(app.filter == 'year'){
            chart.data.labels.forEach((l, i) => {
              if(chart.data.labels.length === (i+1)) {
                var value = l;
                var x = xAxis.getPixelForValue(l);        
                ctx.fillStyle = value == 60 ? 'red' : 'blue';
                ctx.fillText(value, x, yAxis.bottom + 17);
              }
            });
          }
          ctx.restore();
        }
      });
    }
  }
}
</script>